import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import AlphabeticalFilterNavigation from "./Navigation";
import AlphabeticalFilterList from "./List";
import Pagination from "./../../Catalog/Navigation";
import Loading from "./../../Components/Loading";

export default class AlphabeticalFilter extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            filterBy: "A",
            pageSize: 50,
            currentPage: 1,
            total: 1,
            values: [],
            isloading: false
        };

        this.fetchData = this.fetchData.bind(this);
        this.getManufacturersByLetter = this.getManufacturersByLetter.bind(this);
    }
    componentDidMount(){
        this.fetchData();
    }
    componentDidUpdate(prevProps, prevState){
        let {filterBy, currentPage, pageSize} = this.state;

        if(filterBy !== prevState.filterBy || currentPage !== prevState.currentPage || pageSize !== prevState.pageSize){
            this.fetchData();
        }
    }
    fetchData(){
        this.setState({
            isLoading: true
        }, ()=>{
            let {filterGroups} = this.props,
                params = "?";

            if(this.state.filterBy !== "All"){
                filterGroups[0].value = `${this.state.filterBy}%25`;
            } else {
                filterGroups[0].value = undefined;
                filterGroups[0].condition = "notnull";
            }

            params += `filterGroups=${JSON.stringify(filterGroups)}&`;

            params += `pageSize=${this.state.pageSize}&currentPage=${this.state.currentPage}&`;

            params += `fields=response[total,${this.props.listKey}[${this.props.titleKey},${this.props.linkKey}]]&`;

            params += `sortOrders=[{"field":"${this.props.titleKey}","direction":"ASC"}]`;

            axios.get(`${this.props.async}${params}`)
                .then(({data})=>{
                    this.setState({
                        values: data[this.props.listKey],
                        total: data.total,
                        isLoading: false
                    });
                }).catch((err)=>{
                    this.setState({
                        isLoading:false
                    });
                    console.error(err);
                });
        });
    }
    render(){
        return(
            <div>
                <AlphabeticalFilterNavigation handleChange={this.getManufacturersByLetter} />

                <Loading isLoading={this.state.isLoading}>
                    <AlphabeticalFilterList
                        selected={this.state.filterBy}
                        values={this.state.values}
                        linkKey={this.props.linkKey}
                        titleKey={this.props.titleKey}
                        linkPrefix={this.props.linkPrefix}
                    />
                </Loading>

                <Pagination
                    currentPage={this.state.currentPage}
                    pageSizeOptions={[25, 50, 75, 100]}
                    pageSize={this.state.pageSize}
                    showView={false}
                    maxPage={Math.ceil(Number(this.state.total) / Number(this.state.pageSize))}
                    goTo={(newPage)=>{
                        this.setState({
                            currentPage: Number(newPage)
                        });
                    }}
                    changePageSize={(newPageSize)=>{
                        this.setState({
                            pageSize: Number(newPageSize)
                        });
                    }}
                />
            </div>
        );
    }
    getManufacturersByLetter(e){
        e.preventDefault();

        this.setState({
            filterBy: e.target.name,
            currentPage: 1
        });
    }
}

AlphabeticalFilter.propTypes = {
    async: PropTypes.string,
    filterGroups: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string,
            condition: PropTypes.string
        })
    ),
    linkKey: PropTypes.string,
    titleKey: PropTypes.string,
    listKey: PropTypes.string,
    linkPrefix: PropTypes.string
};

export { AlphabeticalFilter, AlphabeticalFilterNavigation, AlphabeticalFilterList};
